<template>
  <div class="caixa-selecao-servidor">
    
    <div v-if="mensagemSucesso" class="mensagem-sucesso">
      {{ mensagemSucesso }}
    </div>

    <fieldset>
      <legend>Selecione um(a) Servidor(a)</legend>

        <MsgErroFormularios
          v-if="erroApi"
          :mensagens="{ api: erroApi }"
          :erro="!!erroApi"
          @fechar-erro="erroApi = null"
        />

      <div class="container-designacao">
        <div class="item-select">
          <label><b>* Servidor:</b></label>
          <v-select
            label="nome"
            :options="servidoresDisponiveis"
            v-model="servidorSelecionado"
            placeholder="Selecione um servidor"
          >
            </v-select>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import ServidorApi from '../../services/ServidorApi';
import FormularioApi from '../../services/FormularioApi';
import MsgErroFormularios from '../MsgErroFormularios.vue'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: 'SelecionarServidor',
  components: { vSelect, MsgErroFormularios },
  props: {
    formularioId: { type: [String, Number], required: true },
    servidoresJaDesignados: { type: Array, default: () => [] },
    servidorEmEdicao: { type: Object, default: null },
    // Usuário autenticado, repassado pelo componente pai (já carregado lá).
    usuarioLogado: { type: Object, default: null },
  },
  data() {
    return {
      servidorSelecionado: [],
      opcoesServidores: [],
      erro: null,
      erroApi: null,
      mensagemSucesso: null,
    };
  },
  created() {
    this.servidorApi = new ServidorApi();
    this.formularioApi = new FormularioApi();
    this.carregarServidoresValidos();
    if (this.servidorEmEdicao) {
      this.servidorSelecionado = this.servidorEmEdicao;
    }
  },
  watch: {
    servidorSelecionado(novaSelecao) {
      this.$emit('servidores-selecionados', novaSelecao ? [novaSelecao] : []);
    },
    servidorEmEdicao(novoServidor) {
      this.servidorSelecionado = novoServidor;
    }
  },
  computed: {
    servidoresDisponiveis() {
      const idsDesignados = this.servidoresJaDesignados.map(s => s.id);

      return this.opcoesServidores.filter(servidor => {
        // Remove o próprio usuário logado da lista: ninguém pode se autoavaliar.
        // Compara por id e por cpf para cobrir variações de payload da API.
        if (this.usuarioLogado) {
          if (servidor.id === this.usuarioLogado.id) return false;
          if (this.usuarioLogado.cpf && servidor.cpf === this.usuarioLogado.cpf) return false;
        }
        if (this.servidorEmEdicao && servidor.id === this.servidorEmEdicao.id) {
          return true;
        }
        return !idsDesignados.includes(servidor.id);
      });
    }
  },
  methods: {
    async carregarServidoresValidos() {
      try {
        const data = await this.servidorApi.getServidoresValidos(this.formularioId);
        this.opcoesServidores = data.resultados;
        if (this.servidorEmEdicao && !this.opcoesServidores.find(s => s.id === this.servidorEmEdicao.id)) {
          this.opcoesServidores.push(this.servidorEmEdicao);
        }
      } catch (err) {
          this.erro = "Erro ao carregar os servidores válidos.";
          console.error(err);
      }
    },

    // LÓGICA DO BOTÃO AGORA DENTRO DESTE COMPONENTE
    async designarFormulario() {
      // 3. ALTERADO: Validação para um único objeto
      if (!this.servidorSelecionado) {
        return;
      }
      try {
        this.erroApi = null;
        this.mensagemSucesso = null;

        // 4. ALTERADO: Cria um array com o único ID
        // O backend espera um array, então enviamos o ID dentro de um.
        const servidorIds = [this.servidorSelecionado.id];

        const response = await this.formularioApi.designarFormulario(this.formularioId, servidorIds);

        this.mensagemSucesso = response.message || "Servidor designado com sucesso!";

        // 5. ALTERADO: Limpa a seleção
        this.servidorSelecionado = null;

        setTimeout(() => { this.mensagemSucesso = null; }, 5000);
        this.$emit('designacao-sucesso');

      } catch (err) {
        console.error("Erro ao designar formulário:", err);
        this.erroApi = err.response?.data?.error || "Ocorreu um erro ao tentar designar o formulário.";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* ESTILOS ADICIONADOS APENAS PARA O NOVO LAYOUT */
.caixa-selecao-servidor { background-color: #fff; padding: 1.5rem; border: 1px solid #ddd; border-radius: 8px; margin-bottom: 2rem; }
fieldset { border: none; padding: 0; }
legend { font-size: 1.2rem; font-weight: bold; margin-bottom: 1rem; color: #005516; }

.container-designacao {
  display: flex;
  align-items: flex-end; /* Alinha na base */
  gap: 1rem;
}
.item-select {
  flex-grow: 1; /* Faz o select ocupar o espaço */
}
label { display: block; margin-bottom: 0.5rem; font-weight: bold; }
.mensagem-erro { margin-top: 1rem; color: #d9534f; font-weight: bold; }

.mensagem-sucesso {
  padding: 1rem;
  background-color: #d4edda; /* Verde claro */
  color: #155724; /* Verde escuro */
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: bold;
}

.bt-designar {
  /* Padding horizontal aumentado de 1rem para 2.5rem */
  padding: 0.4rem 2.5rem; 
  background-color: #005516;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
  height: 2.2rem;
}
.bt-designar:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.bt-designar:hover:not(:disabled) {
  background-color: #238320;
}

::v-deep .vs__dropdown-toggle { border: solid 0.1rem #ccc; border-radius: 0.5rem; height: 2.2rem; }
</style>